function hashToNumber(str: string, maxReturnValue = 6): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0; // simple hash
  }
  return hash % maxReturnValue; // returns 0, 1, 2, 3, 4, or 5
}

export { hashToNumber };
